import { useTranslation } from "react-i18next";

import { ShowBtnCellProps } from "../DamagedItemsTable.types";

import styles from "../DamagedItemsTable.module.scss";

const ShowBtnCell = ({ onClick }: ShowBtnCellProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.damagedItemsTable_showCell} onClick={onClick}>
      {t("Show item")}
    </div>
  );
};

export default ShowBtnCell;
